import React, { Component } from 'react';
import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import PostPicture from '../PostPicture';
import './AuctionFinished.css';

class AuctionFinished extends Component {
  render() {
    const {
      post,
      user,
      showLegacyFeed,
      toggleComments,
      onUnpinWallPost,
      onPinWallPost,
      onLikePost,
      onUnlikePost,
      onDeletePost,
      onLockWallPost,
      onUnlockWallPost
    } = this.props;

    const json = JSON.parse(post.message);
    const { name: auctionName, start, winner } = json;

    const startDate = moment(fromIso9075DateString(start));
    const timeString = startDate
      .format(startDate.minutes() ? 'h:mm A' : 'h A')
      .replace(' ', '\u00A0');
    const className = showLegacyFeed
      ? 'legacy-feed-auction-finished'
      : 'feed-auction-finished';

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon size={30} src={WindCreekWImage} />
          <div className="feed-message-author-container">
            <strong>An Auction has finished!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div className="auction-finished-container">
          <PostPicture
            date={fromIso9075DateString(post.created)}
            alt="An Auction has finished"
          />
          <div className="auction-finished-message">
            <span className="auction-finished-title">{auctionName}</span>
            <div className="auction-finished-message-winner">
              Congratulations to
              <span className="auction-finished-name"> {winner}</span> on
              winning our {timeString} Auction! Your prize has been added to
              your account.
            </div>
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          showLegacyFeed={showLegacyFeed}
          toggleComments={toggleComments}
          onUnpinWallPost={onUnpinWallPost}
          onPinWallPost={onPinWallPost}
          onLikePost={onLikePost}
          onUnlikePost={onUnlikePost}
          onDeletePost={onDeletePost}
          onLockWallPost={onLockWallPost}
          onUnlockWallPost={onUnlockWallPost}
        />
      </div>
    );
  }
}

AuctionFinished.propTypes = {
  user: userShape,
  post: wallPostShape,
  showLegacyFeed: PropTypes.bool,
  onDeletePost: PropTypes.func,
  toggleComments: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func,
  onPinWallPost: PropTypes.func,
  onUnpinWallPost: PropTypes.func
};

export default AuctionFinished;
